export enum TrayType {
    Normal,
    Service
}
